import { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { ImageModalProps } from './image-modal.types';
import { StyledImage, StyledImageOverlay, StyledImageWrapper, StyledModalCloseIcon } from './image-modal.styles';
export const ImageModal = ({
  imageElement,
  setImageElement
}: ImageModalProps) => {
  const closeImageModal = useCallback(() => {
    setImageElement(null);
  }, [setImageElement]);
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.code === 'Escape') {
        closeImageModal();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [imageElement, setImageElement, closeImageModal]);
  if (imageElement && imageElement?.nodeName === 'IMG' && imageElement?.parentElement?.nodeName !== 'A') {
    const isSvg = new URL(imageElement.src).pathname.toLowerCase().endsWith('.svg');
    return createPortal(<>
        <StyledImageOverlay data-testid="modal-image-overlay" onClick={closeImageModal} />
        <StyledImageWrapper data-testid="modal-image-wrapper" isSvg={isSvg}>
          <StyledModalCloseIcon data-testid="modal-image-close" onClick={closeImageModal} icon={faClose} />
          <StyledImage alt={imageElement.src} src={imageElement.src} isSvg={isSvg} />
        </StyledImageWrapper>
      </>, document.body);
  }
  return null;
};